module.exports = __webpack_public_path__ + "static/media/harina_alpesaespecial.6164f81b.png";